import React from "react";
import Head from "../../Page";
import Footer from "../../components/Footer";
import GalleryNavbar from "../../components/GalleryNavbar";
import DocumentsContent from "../../components/Documents/DocumentsContent";

const Document = () => {
  return (
    <Head title="Documente">
      <GalleryNavbar />
      <DocumentsContent />

      <Footer />
    </Head>
  );
};

export default Document;
